import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { getUserInfo } from '../../Config/Auth';

import Sidebar from '../Components/Sidebar/Sidebar';
import Navbar from '../Components/Navbar/Navbar';

import Profile from '../Components/Profile/Profile';
import Dashboard from '../Pages/Dashboard/Dashboard';
import Jobs from '../Pages/Jobs/Jobs';
import Invoices from '../Pages/Invoices/Invoices';
import Notes from '../Pages/Notes/Notes';
import Supervisors from '../Pages/Supervisors/Supervisors';
import SiteUsers from '../Pages/SiteUsers/SiteUsers';
import Notifications from '../Pages/Notifications/Notifications';
import Settings from '../Pages/Settings/Settings';

import ProtectedRoute from './ProtectedRoute';

const CCRoutes = () => {
  const location = useLocation();
  const user = getUserInfo();
  const isInitialActivated = user?.initialActivated ?? true;

  const shouldRedirect = !isInitialActivated && location.pathname !== '/cc/dashboard';

  return (
    <div className="app">
      <Sidebar />
      <div className="main-content">
        <Navbar />
        {shouldRedirect ? (
          <Navigate to="/cc/dashboard" replace />
        ) : (
          <Routes>
            <Route path="/profile" element={<ProtectedRoute>  <Profile /> </ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute requiredPermission={{ section: 'dashboard', keys: ['dashboard_view'] }}> <Dashboard /> </ProtectedRoute>} />
            <Route path="/jobs" element={<ProtectedRoute requiredPermission={{ section: 'jobs', keys: ['jobs_view', 'jobs_edit'] }}> <Jobs /> </ProtectedRoute>} />
            <Route path="/invoices" element={<ProtectedRoute requiredPermission={{ section: 'invoices', keys: ['invoices_view', "invoices_update"] }}> <Invoices /> </ProtectedRoute>} />
            <Route path="/notes" element={<ProtectedRoute requiredPermission={{ section: 'notes', keys: ['notes_view', 'notes_edit'] }}>  <Notes /> </ProtectedRoute>} />
            <Route path="/supervisors" element={<ProtectedRoute requiredPermission={{ section: 'supervisors', keys: ['supervisors_view', 'supervisors_edit'] }}>  <Supervisors /> </ProtectedRoute>} />
            <Route path="/siteusers" element={<ProtectedRoute requiredPermission={{ section: 'site users', keys: ['siteusers_view', 'siteusers_edit'] }}> <SiteUsers /> </ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute requiredPermission={{ section: 'notifications', keys: ['notifications_view', 'notifications_manage'] }}> <Notifications /> </ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute requiredPermission={{ section: 'settings', keys: ['settings_view', 'settings_edit'] }}> <Settings /> </ProtectedRoute>} />
          </Routes>
        )}
      </div>
    </div>
  );
};

export default CCRoutes;
